<template>
  <div class="custom-titlebar">
    <div class="title">
        <span class="title-text">{{ pageTitle }}</span>
    </div>
    <div class="buttons">
        <button @click="minimize"><i class="bi bi-dash-lg"></i></button>
        <button @click="toggleMaximize">
        <i :class="isMaximized ? 'bi bi-subtract' : 'bi bi-square'"></i>
        </button>
        <button class="close" @click="close"><i class="bi bi-x-lg"></i></button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMaximized: false,
    };
  },
  computed: {
    pageTitle() {
        const title = this.$route.meta.title;
        return title ? `${title} | UformPanel` : 'UformPanel';
    }
  },
  mounted() {
    // Ouça eventos do main para saber quando a janela é maximizada/restaurada
    if (window.electronAPI?.onMaximizeChange) {
      window.electronAPI.onMaximizeChange((event, maximized) => {
        this.isMaximized = maximized;
      });
    }
  },
  methods: {
    minimize() {
      window.electronAPI?.minimize();
    },
    toggleMaximize() {
      window.electronAPI?.maximize();
      this.isMaximized = !this.isMaximized; // Alterna o estado local
    },
    close() {
      window.electronAPI?.close();
    }
  }
}
</script>

<style scoped>
.custom-titlebar {
  display: flex;
  justify-content: flex-end;
  background-color: var(--color-background);
  padding: 0;
  position: fixed;
  width: 100%;
  height: var(--electron-top-frame-height);
  z-index: 20;
  -webkit-app-region: drag; /* Permite arrastar a janela */
}
.custom-titlebar .title {
    flex: 1;
    padding-left: calc(var(--electron-top-frame-height) * 1.35 * 3);
    text-align: center;
    line-height: var(--electron-top-frame-height);
}
.custom-titlebar .buttons {
  -webkit-app-region: no-drag; /* Botões continuam clicáveis */
}
.custom-titlebar button {
  background: none;
  border: none;
  color: var(--color-text-secondary);
  font-size: 16px;
  margin-left: 10px;
  padding: 0;
  margin: 0;
  width: calc(var(--electron-top-frame-height) * 1.35);
  height: var(--electron-top-frame-height);
  text-align: center;
  cursor: pointer;
  line-height: var(--electron-top-frame-height);
}
.custom-titlebar button:hover {
  color: var(--color-text);
  background-color: var(--color-text-disabled-secondary);
}
.custom-titlebar button.close:hover {
  color: #FFF;
  background-color: var(--color-btn-red-hover);
}
.custom-titlebar button:focus {
  outline: none;
}
.custom-titlebar button:active {
  color: var(--color-text);
}
.custom-titlebar button:disabled {
  color: var(--color-text-disabled);
  cursor: not-allowed;
}
.custom-titlebar button i.bi-square {
    font-size: 0.85em;
}
</style>